<div style="display: flex; align-items: center; gap: 0.5rem">
  <label class="block ms-2 text-sm font-medium text-gray-500 whitespace-nowrap" for="minorReleaseNumber">NW</label>
  <input
    class="block w-full text-xs text-gray-500 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none"
    id="nwNumberNumber"
    type="number"
    min="1"
    max="999"
    (change)="onNumberChanged($event)"
  />
</div>
